import React, { useContext, useEffect } from "react"
import { LanguageContext, languages, Locale } from "@/contexts/language"
import { CaretSortIcon, CheckIcon } from "@radix-ui/react-icons"

import { cn } from "@/lib/utils"
import { Button } from "@/components/ui/button"
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
} from "@/components/ui/command"
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover"

export function LanguageToggle() {
  const { locale, setLocale } = useContext(LanguageContext)
  const [open, setOpen] = React.useState(false)

  useEffect(() => {
    window.localStorage.setItem("locale", locale)
  }, [locale])

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          role="combobox"
          aria-expanded={open}
          className="w-[60px] justify-between"
        >
          {languages.find((language) => language.value === locale)?.label}
          <CaretSortIcon className="ml-2 h-4 w-4 shrink-0 opacity-50" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-[60px] p-0">
        <Command>
          <CommandGroup>
            {languages.map((language) => (
              <CommandItem
                key={language.value}
                onSelect={(currentValue) => {
                  setLocale(language.value)
                  setOpen(false)
                }}
              >
                {language.label}
                <CheckIcon
                  className={cn(
                    "ml-auto h-4 w-4",
                    locale === language.value ? "opacity-100" : "opacity-0"
                  )}
                />
              </CommandItem>
            ))}
          </CommandGroup>
        </Command>
      </PopoverContent>
    </Popover>
  )
}
